module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pdMonths":"PD 12 months","pdLifetime":"PD lifetime","lgd":"LGD","pdIncremental":"Incremental PD","ccf":"CCF"},"et":{"pdMonths":"PD 12 months","pdLifetime":"PD lifetime","lgd":"LGD","pdIncremental":"Incremental PD","ccf":"CCF"},"ru":{"pdMonths":"PD 12 months","pdLifetime":"PD lifetime","lgd":"LGD","pdIncremental":"Incremental PD","ccf":"CCF"}}')
  delete Component.options._Ctor
}
